/* eslint-disable import/prefer-default-export */
export const it = {
  translation: {
    title: 'Convalidare copia autorizzata elettronica',
    desc:'Inserisci il CSV (Codice Sicuro di Verifica) e premi il pulsante Convalidare per verificare l’autenticità e l’integrità della copia autorizzata elettronica del documento notarile, nonché per consultare le successive note di modifica giuridica e di coordinamento con altri strumenti pubblici.',
    placeholderCSV:'Codice CSV',
    validateButton: 'Convalidare',
    backButton:'Indietro',
    okButton:'Accettare',
    cancelButton:'Annulla',
    closeButton:'Chiudere',
    actionsButton:'Azioni',
    downloadButton:'Scaricare',
    head: {
      title: 'SEDE ELETTRONICA NOTARILE',
    },
    footer: {
      legalNotice: 'Avviso legale',
      privacyPolicy: 'Informativa sulla privacy',
      accessibility: 'Accessibilità',
      cookiesPolicy: 'Informativa sui cookie',
      supportedBrowsers: 'Browser supportati',
    },
    modalsupportedbrowsers:{
      other: 'Puoi accedere utilizzando un PC, Mac, dispositivo mobile o tablet.',
    },
    actions: {
      helpButton:'Visualizza aiuto',
      validateSignature:'Convalidare firma',
      download:'Scaricare',
      downloadCombined: 'Scaricare uniti'
    },
    modalAyuda:{
      title:'Aiuto',
      guide:'Qui puoi scaricare la guida relativa a questa sezione',
      section1: 'Verificare la validità della firma tramite la Sede Elettronica Notarile',
      desc1: 'Per verificare la validità della firma elettronica qualificata del notaio sul documento notarile, fai clic sul pulsante <strong>Azioni</strong> e seleziona <strong>Convalidare firma</strong>.',
      section2: 'Verificare la validità della firma tramite Adobe Acrobat Reader',
      desc2: 'Per verificare la validità della firma elettronica qualificata del notaio sul documento notarile, fai clic sul pulsante <strong>Azioni</strong> e seleziona <strong>Scaricare</strong>. Successivamente, apri il documento con Adobe Acrobat Reader e fai clic sull’icona della penna situata nel menu laterale. <br /><br /> Nell’elenco a discesa potrai verificare la validità della firma e analizzarne i dettagli.',
      section3: 'Verificare la validità della firma tramite VALIDe',
      desc3: 'Per verificare la validità della firma elettronica qualificata del notaio sul documento notarile, fai clic sul pulsante <strong>Azioni</strong> e seleziona <strong>Scaricare</strong>. Successivamente, utilizza la',
      linkText: 'piattaforma pubblica VALIDe',
    },
    modalCopia:{
      title:'Copia autorizzata elettronica',
    },
    modalErrorServicio:{
      desc: 'Non esiste alcuna copia autorizzata elettronica associata al codice CSV inserito. Verifica il codice e riprova.',
      contactSupport: 'Se il problema persiste, puoi contattare il servizio di supporto.',
    },
    modalAdvertenciaDescarga:{
      title:'Avvertenza',
      desc:'<strong>Le note</strong> di modifica giuridica e di coordinamento con altri strumenti pubblici <strong>emesse dopo il rilascio della copia non saranno disponibili nel documento che stai per scaricare.</strong> Sono riportate solo nella ricevuta di rilascio della copia.',
    },
    modalErrorGenerico:{
      desc:'Si è verificato un problema. Riprova.',
    },
    modalErrorValidacion:{
      title:'Errore nella convalida della firma.',
      desc:'Non è stato possibile convalidare la firma del documento. Riprova o contatta il servizio di supporto.',
    },
    modalManuales:{
      name:'Nome',
    },
    modalValidacionFirma:{
      title:'Convalidare firma',
      firmaNotario:'FIRMA QUALIFICATA DEL NOTAIO:',
      fechaFirma:'DATA DELLA FIRMA:',
      fechaValidacion:'DATA DI CONVALIDA:',
      estadoFirma:'STATO DELLA FIRMA:',
      validacionFirma:'Convalida della firma elettronica del Consiglio Generale del Notariato',
      validada:'Validata',
      noValidada:'Non validata',
      contenido:'Contenuto del documento',
      alterado:'alterato',
      noAlterado:'non alterato',
      certificadoFirmante:'Certificato del firmatario',
      caducado:'scaduto',
      noCaducado:'non scaduto',
      revocado:'revocato',
      noRevocado:'non revocato',
      certificadoCa:'emesso da un’autorità di certificazione affidabile (CA)',
      noCertificadoCa:'non emesso da una CA affidabile',
    },
  },
};
